// @mui
import { Divider, Stack, Typography } from '@mui/material';
// hooks
// routes
// assets

// ----------------------------------------------------------------------

export default function NavbarDocs() {
  // const { user } = useAuth();

  return (
    <Stack spacing={3} sx={{ px: 5, pb: 5, mt: 2, width: 1, textAlign: 'center', display: 'block' }}>
      {/* <DocIllustration sx={{ width: 1 }} /> */}
      <Divider />
      <div>
        {/* <Typography gutterBottom variant="subtitle1"> */}
        {/*   The PeerXiv Mock */}
        {/* </Typography> */}
        {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}> */}
        {/*   Full experience coming soon! */}
        {/*   /!* <br /> Please check our docs *!/ */}
        {/* </Typography> */}
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          ArXiv is a trademark of Cornell University, used under license. This license should not be understood to
          indicate endorsement of content on peerXiv by Cornell University or ArXiv. peerXiv operates independently and
          has no relationship with ArXiv.
          {/* <br /> Please check our docs */}
        </Typography>
      </div>

      {/* <Button href={PATH_DOCS} target="_blank" rel="noopener" variant="contained"> */}
      {/*  Documentation */}
      {/* </Button> */}
    </Stack>
  );
}
